import script from "./PosttreatmentRetestList.vue?vue&type=script&setup=true&lang=js"
export * from "./PosttreatmentRetestList.vue?vue&type=script&setup=true&lang=js"

import "./PosttreatmentRetestList.vue?vue&type=style&index=0&id=7cd262fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd262fc"]])

export default __exports__